"use client"

// The std surface's client half (docs/30 §5): binds the surface-owned desk
// view and loading widget into the shared host island. This wrapper is what
// keeps the host free of surface imports — the components travel through
// props as client references.
import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { StdRoutedPage } from './deskUi/StdRoutedPage'
import { MsgDeskLoading } from '@/stdDesk/MsgDeskLoading'

export default function StdSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={StdRoutedPage} Loading={MsgDeskLoading} />
}
